export default __webpack_public_path__ + "img/6975454fcde7c8a62edc9f87417f89ec.ico";